//Author June Leow
//Date Nov 14th, 2023
import Accept from './appraisal/accept';
import Acceptance from './appraisal/acceptance';
import AutoAssignAcceptance from './appraisal/auto-assign-acceptance';
import AccountingTickets from './support/accounting-tickets';
import AccountingTicket from './support/accounting-ticket';
import Announcements from './announcement/announcements';
import Appraisal from './appraisal/appraisal';
import Appraisals from './appraisal/appraisals';
import AppraiserFee from './appraisal/appraiser-fee';
import BaseFee from './appraisal/base-fee';
import {bindActionCreators} from 'redux';
import Conditions from './condition/conditions';
import Condition from './condition/condition';
import config from '../config';
import {connect} from 'react-redux';
import Dashboard from './dashboard/dashboard';
import DeskReview from './appraisal/desk-review';
import DesktopReady from './appraisal/desktop-ready';
import UAD36Ready from './appraisal/uad36-ready';
import UAD36ReadyV2 from './appraisal/uad36-before-mandate';
import ENVReady from './appraisal/env-ready';
import ForgotPassword from './login/forgot-password';
import GreenRenovationExp from './appraisal/green-renovation-exp';
import InspectionCompleted from './appraisal/inspection-completed';
import LoadingBar from 'react-redux-loading-bar';
import Login from './login/login';
import {logout} from '../actions/action-login';
import Pusher from 'pusher-js';
import {PusherProvider} from './pusher/pusher-context';
import NewAccountingTicket from './support/new-accounting-ticket';
import NewTicket from './support/new-ticket';
import Notifications from './notification/notifications';
import ResetPassword from './login/reset-password';
import React, {useRef} from 'react';
import {Route, BrowserRouter as Router, Routes, Navigate} from 'react-router-dom';
import Rebuttals from './rebuttal/rebuttals';
import Rebuttal from './rebuttal/rebuttal';
import RemoteReady from './appraisal/remote-ready';
import PersonalSetting from './setting/personal-setting';
import PropertyDataReport from './property-data-report/upd/property-data-report';
import Profile from './setting/profile';
import Support from './support/support';
import SignUp from './login/sign-up';
import SideBar from './structure/side-bar/side-bar';
import TopBar from './structure/top-bar/top-bar';
import Template from './setting/template';
import Tickets from './support/tickets';
import Ticket from './support/ticket';
import UniformPropertyDatasetPDF from './property-data-report/upd/pdf';
import UPDPostCompletionReport from './property-data-report/upd/post-completion-report';
import { ToastContainer} from 'react-toastify';
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import AppraiserFileUpload from './file/appraiser-file-upload';



const App  = (props)=>{
  let pusher = new Pusher(config.pusherAppKey,{
    authEndpoint: config.baseAPIUrl + 'session/notification_auth',
    auth:{
      headers: {
        'Authorization': "Authorization: Bearer "+localStorage.getItem('token')
      }
    },
    cluster: config.pusherCluster
  });

  const container = useRef();

  if(props.isLoggedIn){
    return (
      <div>
        <PusherProvider pusher={pusher}>
          <Router>
            <div style={{height:'100%'}}>
              <ToastContainer theme="colored" className="my-toast-container always-on-top"/>
              <LoadingBar style={{zIndex:'99'}}/>
              <div className="container-fluid">
                <div className="row">
                  <div className="col-sm-12 col-md-12 no-padding">
                    <TopBar {...props} userFirstName={props.userFirstName} userLastName={props.userLastName} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>
                  </div>
                </div>

                <div className="row page-content">
                  <div className="col-sm-2 col-md-2 no-padding">
                    <SideBar logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc} {...props} isLoggedIn={props.isLoggedIn}/>
                  </div>

                  <div  id="contentContainer" className="col-sm-10 col-md-10 padding content-container" ref={container}>
                    <Routes>
                      <Route
                        exact path="/"
                        element={<Dashboard {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/uniform-property-dataset/:updFk"
                        element={<PropertyDataReport {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/uniform-property-dataset/file/:updFk"
                        element={<UniformPropertyDatasetPDF {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/uniform-property-dataset/post-completion-report/:updFk"
                        element={<UPDPostCompletionReport {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/announcement"
                        element={<Announcements {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/notification"
                        element={<Notifications {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/setting"
                        element={<PersonalSetting {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/setting/profile"
                        element={<Profile {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/setting/template/:id"
                        element={<Template {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/support/ticket"
                        element={<Tickets {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/support/ticket/:id"
                        element={<Ticket {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/support/new"
                        element={<NewTicket {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/support/accounting/new"
                        element={<NewAccountingTicket {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/support/accounting/ticket"
                        element={<AccountingTickets {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/support/accounting/ticket/:id"
                        element={<AccountingTicket {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/support"
                        element={<Support {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                     <Route
                        exact path="/dashboard"
                        element={<Dashboard {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/appraisal/acceptance/:id/:appraiserFk"
                        element={<Acceptance {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/appraisal/auto-assign-acceptance/:id/:appraiserFk/:email"
                        element={<AutoAssignAcceptance {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/appraisal/inspection-completed/:id"
                        element={<InspectionCompleted {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/appraisal/accept/:id/:appraiserFk"
                        element={<Accept {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/desktop/:id/:email/:desktopAppraisalReady"
                        element={<DesktopReady {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/uad36-survey-before-mandate/:id/:email"
                        element={<UAD36ReadyV2 {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/uad36/:id/:email/:UAD36Ready"
                        element={<UAD36Ready {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/green-renovation-exp/:id/:email/:expLevel"
                        element={<GreenRenovationExp {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/remote/:id/:email/:remoteAppraisalReady"
                        element={<RemoteReady {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/env-ready/:id/:email/:envReady"
                        element={<ENVReady {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/appraisal/base-fee/:id/:email"
                        element={<BaseFee {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                       <Route
                        exact path="/appraisal/appraisers/fees/:id/:email"
                        element={<AppraiserFee {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/desk-review/:id/:email"
                        element={<DeskReview {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/appraisal/:id"
                        element={<Appraisal {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/appraisal"
                        element={<Appraisals {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/condition/:id"
                        element={<Condition {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/condition"
                        element={<Conditions {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/rebuttal/:id"
                        element={<Rebuttal {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/rebuttal"
                        element={<Rebuttals {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                      <Route
                        exact path="/file/appraiser-file-upload/:params"
                        element={<AppraiserFileUpload {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
                      />
                    </Routes>
                  </div>
                </div>
              </div>
            </div>
          </Router>
        </PusherProvider>
     </div>
   );
  }
  else{
    return (
      <div>
        <ToastContainer theme="colored" className="my-toast-container always-on-top"/>
        <LoadingBar style={{zIndex:'99'}}/>
        <Router>
          <div id="contentContainer" className="content-container" ref={container}>
            <Routes>
              <Route
                exact path="/green-renovation-exp/:id/:email/:expLevel"
                element={<GreenRenovationExp {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
              />
              <Route
                exact path="/sign-up"
                element={<SignUp {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
              />
              <Route
                exact path="/remote/:id/:email/:remoteAppraisalReady"
                element={<RemoteReady {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
              />
              <Route
                exact path="/desktop/:id/:email/:desktopAppraisalReady"
                element={<DesktopReady {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
              />
              <Route
                exact path="/uad36-survey-before-mandate/:id/:email"
                element={<UAD36ReadyV2 {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
              />
              <Route
                exact path="/uad36/:id/:email/:UAD36Ready"
                element={<UAD36Ready {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
              />
              <Route
                exact path="/env-ready/:id/:email/:envReady"
                element={<ENVReady {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
              />
              <Route
                exact path="/appraisal/acceptance/:id/:appraiserFk"
                element={<Acceptance {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
              />
              <Route
                exact path="/appraisal/auto-assign-acceptance/:id/:appraiserFk/:email"
                element={<AutoAssignAcceptance {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
              />
              <Route
                exact path="/appraisal/appraisers/fees/:id/:email"
                element={<AppraiserFee {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
              />
              <Route
                exact path="/appraisal/accept/:id/:appraiserFk"
                element={<Accept {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
              />
              <Route
                exact path="/appraisal/inspection-completed/:id"
                element={<InspectionCompleted {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
              />
              <Route
                exact path="/appraisal/base-fee/:id/:email"
                element={<BaseFee {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
              />
              <Route
                exact path="/desk-review/:id/:email"
                element={<DeskReview {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
              />
              <Route
                exact path="/forgot-password"
                element={<ForgotPassword {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
              />
              <Route
                exact path="/reset-password/:email/:token"
                element={<ResetPassword {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
              />
              <Route
                path="/"
                element={<Login {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}
              />
              <Route path="*" element={<Login {...props} logout={props.logout} showLoading={props.dispatchShowLoadingFunc} hideLoading={props.dispatchHideLoadingFunc}/>}/>
            </Routes>
          </div>
        </Router>
      </div>
    );
  }
}

function mapStateToProps(state){
  return {
    jwtToken: state.session.jwtToken,
    isLoggedIn: state.session.isLoggedIn,
    userRole: state.session.userRole,
    userFirstName: state.session.userFirstName,
    userLastName: state.session.userLastName
  };
}

function matchDispatchToProps(dispatch){
  return bindActionCreators({
    logout: logout,
    dispatchShowLoadingFunc: ()=>{return showLoading()},
    dispatchHideLoadingFunc: ()=>{return hideLoading()},
  },dispatch);
}

export default connect(mapStateToProps,matchDispatchToProps)(App);
